import styled from 'styled-components';
import theme from '../../styles/theme.css';

export const Foot = styled.footer`
    max-width: 100vw;
    display: grid;
    grid-template-areas: 'logoLT logoAJ logoAJ logoLab'
                        'logoLT bajada bajada logoLab';
    @media (max-width: 640px){
        grid-template-areas: 'logoAJ logoAJ'
                                'logoLT logoLab'
                                'bajada bajada';
    }
    div{
        display: flex;
        justify-content: center;
        align-items: center;
      
        &:nth-child(1){
            grid-area: logoLT;
            padding: 0 20px;
            svg{
                width: 120px;
                max-width: 100%;
            }
        }
        &:nth-child(2){
            grid-area: logoAJ;
            padding: 20px 0 10px 0;
        }
        &:nth-child(3){
            grid-area: bajada;
            padding: 0 20px 0 20px;
            @media (max-width: 640px){
                padding: 0 40px;
                text-align: center;
            }

            p{
                font-size: 0.7rem;
                font-family: ${theme.plexMono};
                font-weight: 600;
            }
        }
        &:nth-child(4){
            grid-area: logoLab;
            padding: 0 20px;
            img{
                width: 100%;
                max-width: 120px;
            }
        }
    }
`